import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { CashPosition } from '../../models/cash-position.model';
import { CashPositionsActions } from './cash-positions.actions';

export interface CashPositionsState extends EntityState<CashPosition> {
  loading: boolean;
  error: string | null;
}

export const adapter = createEntityAdapter<CashPosition>();
const initialState: CashPositionsState = adapter.getInitialState({ loading: false, error: null });

export const cashPositionsFeature = createFeature({
  name: 'cashPositions',
  reducer: createReducer(
    initialState,
    on(CashPositionsActions.loadCashPositions, (state) => ({ ...state, loading: true, error: null })),
    on(CashPositionsActions.loadCashPositionsSuccess, (state, { positions }) =>
      adapter.setAll(positions, { ...state, loading: false })),
    on(CashPositionsActions.loadCashPositionsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  )
});

export const {
  name: cashPositionsFeatureKey,
  reducer,
  selectCashPositionsState,
  selectLoading: selectCashPositionsLoading,
} = cashPositionsFeature;

export const { selectAll } = adapter.getSelectors();
